import { registerQuery } from 'data-fetching-client';
import { fetchAssignableUserIds, fetchDeactivatedUserIds } from 'automation-ui-action-features/users-and-teams/usersApi';
export const GET_ASSIGNABLE_USER_IDS = registerQuery({
  fieldName: 'assignableUserIds',
  fetcher: fetchAssignableUserIds
});
export const GET_DEACTIVATED_USER_IDS = registerQuery({
  fieldName: 'deactivatedUserIds',
  fetcher: fetchDeactivatedUserIds
});